export default __webpack_public_path__ + "static/media/Pernod.7a0bb218.png";